import { render } from "./SpecialFeatureItem.vue?vue&type=template&id=00dbd71c&scoped=true&ts=true"
import script from "./SpecialFeatureItem.vue?vue&type=script&lang=ts"
export * from "./SpecialFeatureItem.vue?vue&type=script&lang=ts"

import "./SpecialFeatureItem.vue?vue&type=style&index=0&id=00dbd71c&scoped=true&lang=scss"

import exportComponent from "/home/gui/adm/gpp-cmp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00dbd71c"]])

export default __exports__